"use client";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import * as yup from "yup";
import {useForm, useWatch} from "react-hook-form";
import {Form} from "@/components/ui/form";
import {CWFInput} from "@/components/ui/CWFInput";
import CWFButton from "@/components/ui/CWFButton";
import toast from "react-hot-toast";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import {useState} from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import CWFTextarea from "@/components/ui/CWFTextarea";
import {useRouter} from "next/navigation";

const REQUIRED_ERROR = "Ce champs est requis.";
const formSchema = yup.object({
    content : yup.string().required(),
})

export default function PrivateMessageModal({privateMessageOpen,setPrivateMessageOpen,id}) {
    const axios = useAxiosAuth();
    const router = useRouter();
    const [loading, setLoading] = useState(false);



    const messageForm = useForm({
        resolver: yupResolver(formSchema),
    })

    function createGroup(data){
        setLoading(true);
        axios.post('conversations', {
            users: [id],
            message : data.content
        })
        .then(response => {
            router.push(`/dashboard/messages/${response.data.data.id}`)
        }).catch((error) => {
            toast.error("Une erreur s'est produite");
        }).finally(() => {
            setLoading(false);
            setPrivateMessageOpen(false);
        })
    }

    return (
        <CWFResponsiveDialog
            title={"Envoyez le premier message"}
            open={privateMessageOpen}
            onOpenChange={setPrivateMessageOpen}
            trigger={null}
        >
            <Form {...messageForm}>
                <form onSubmit={messageForm.handleSubmit(createGroup)} className={"grid gap-2"}>
                    <CWFTextarea control={messageForm.control} name={"content"} label={"Message"}/>
                    <CWFButton loading={loading}>
                        Envoyer
                    </CWFButton>
                </form>
            </Form>
        </CWFResponsiveDialog>
    )
}